"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxonomyTerms = exports.TaxonomySystemAttributes = exports.TaxonomyGroup = void 0;
var TaxonomyGroup = /** @class */ (function () {
    function TaxonomyGroup(system, terms) {
        this.system = system;
        this.terms = terms;
    }
    return TaxonomyGroup;
}());
exports.TaxonomyGroup = TaxonomyGroup;
var TaxonomySystemAttributes = /** @class */ (function () {
    function TaxonomySystemAttributes(data) {
        Object.assign(this, data);
    }
    return TaxonomySystemAttributes;
}());
exports.TaxonomySystemAttributes = TaxonomySystemAttributes;
var TaxonomyTerms = /** @class */ (function () {
    function TaxonomyTerms(data) {
        Object.assign(this, data);
    }
    return TaxonomyTerms;
}());
exports.TaxonomyTerms = TaxonomyTerms;
//# sourceMappingURL=taxonomy-models.js.map